export const BASKET_URL = 'basket';
